define('controllers/leftnav/Podio.Controllers.LeftNav.Main',['require','jquery','lib/backbone/Backbone.PodioController','models/Podio.Models.Space','models/Podio.Models.Organization','collections/Podio.Collections.Organizations','views/leftnav/Podio.Views.LeftNav.OrgNav','lib/Podio.Utils'],function(require) {

  var $ = require('jquery');
  var PodioController = require('lib/backbone/Backbone.PodioController');

  var SpaceModel = require('models/Podio.Models.Space');
  var OrganizationModel = require('models/Podio.Models.Organization');
  var OrganizationCollection = require('collections/Podio.Collections.Organizations');
  var OrgNavView = require('views/leftnav/Podio.Views.LeftNav.OrgNav');
  var podioUtils = require('lib/Podio.Utils');

  return PodioController.extend({

    initialize: function(options) {

      if (!podioUtils.loggedIn()) {
        // We are not logged in, so lets get out of here
      }

      this._super();

      this.organizations = this.options.organizations;
      this.currentOrganization = this.options.currentOrganization;

      // Rendering
      if (this.organizations) {
        this.initOrgNav();
      }

    },

    initOrgNav: function() {

      this.orgNavView = new OrgNavView({
        eventBus: this.eventBus,
        organizations: this.organizations,
        currentOrganization: this.currentOrganization,
        el: $('#org-nav')
      });

      this.orgNavView.render();

    }

  });

});

